import { useEffect, useState } from "react";
import { getTestAxisDegrees } from "../util/TestLabelsUtil";
import test_entry_config from "../config/test_entry_config.json";
import SimpleTestChart, { SimpleTestPoint } from "../charts/SimpleTestChart";
import { getZoneSymbolKind } from "@utils/TestUtils";
import { VFABehaviour } from "types/testTypes";

interface SimpleTestMapProps {
  values: number[] | null[];
  testType: string;
  eye: string;
  testBehaviour?: VFABehaviour | string;
}

const SimpleTestMap: React.FC<SimpleTestMapProps> = (props) => {
  const [elements, setElements] = useState<SimpleTestPoint[]>([]);

  const degreeValue = getTestAxisDegrees(props.testType, false, false) as number;
  const degreeString = getTestAxisDegrees(props.testType);
  const dotRadiusScale = 0.015;

  useEffect(() => {
    const simpleTestConfig = test_entry_config["simpleTests"];
    const testCfg = simpleTestConfig?.[props.testType];
    if (!testCfg) {
      console.warn("SimpleTestMap: unknown simple testType", props.testType);
      setElements([]);
      return;
    }
    // Binocular Esterman tests only have "bothEye".
    const eyeKey = testCfg?.[props.eye] ? props.eye : testCfg?.bothEye ? "bothEye" : props.eye;
    const config = testCfg?.[eyeKey];
    if (!config?.angleCoordinates || !Array.isArray(config.angleCoordinates)) {
      console.warn("SimpleTestMap: missing config for", {
        testType: props.testType,
        eye: props.eye,
        resolvedEyeKey: eyeKey,
        availableKeys: Object.keys(testCfg ?? {}),
      });
      setElements([]);
      return;
    }
    const points: SimpleTestPoint[] = config.angleCoordinates.map(([xDeg, yDeg], i) => ({
      xDeg,
      yDeg,
      kind: getZoneSymbolKind(props.values[i], props.testBehaviour),
    }));
    setElements(points);
  }, [props.values, props.testType, props.eye, props.testBehaviour]);

  return (
    <SimpleTestChart
      points={elements}
      backgroundUrl={`/img/test_backgrounds/simple-${degreeValue}.png`}
      maxXDeg={degreeValue}
      maxYDeg={degreeValue}
      dotRadiusDeg={degreeValue * dotRadiusScale}
      sideLabel={String(degreeString)}
    />
  );
};

export default SimpleTestMap;
